<template>
    <div>
      <div class="modal fade" id="modal-asig-aula" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
            <div class="modal-body">
                <form @submit.prevent="validarCampos" style="margin-top:0;" novalidate>
                    <h3 class="text-center"> Asignar Aula al Modulo </h3>
                   
                    <div class="row">
                        <div class="col-sm-2"> <b>Modulo:</b> </div>
                        <div class="col-sm-10"> {{mod.nombre}} </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-2"> <b>Sede:</b> </div>
                        <div class="col-sm-10"> <Sedes :model="sede" :default="programa.sede"/> </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-2"> <b>Aula:</b> </div>
                        <div class="col-sm-10"> <Aulas :model="aula" :sede="sede"/> </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-2"> <b>Dias:</b> </div>
                        <div class="col-sm-10"> <ASemanasAula :model="semana"/> </div>
                    </div>

                    <p class="text-center text-danger"> {{msg}} </p>
                    <Alertas ref="alertar" />

                    <button class="btn btn-azul center-block" type="submit"> Asignar aula a este modulo </button>
                </form>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
            </div>
            </div>
        </div>
      </div>
    </div>  
</template>

<script>
import ASemanasAula from '@/components/ASemanasAula'
import Sedes from '@/components/ASedes'
import Alertas from '@/components/AAlertas'
import Aulas from '@/components/AAulas'
import gql from 'graphql-tag'
export default {
  props:{ mod:{type:Object,required:true} },
  data(){
    return{
      msg: '',
      programa:{sede:{}},
      sede: {idsede:{}},
      aula:{idaula:{}},
      semana: {idsemana:[]},
    }
  },
  components:{ Sedes,Aulas,ASemanasAula,Alertas },
  watch:{
  },
  methods:{
    validarCampos(){
      this.msg = '';
      if( this.programa == null ){
        this.msg = 'No hay un programa seleccionado.';
        return;
      }
      if( !this.mod || !this.mod.id ){
        this.msg = 'No hay modulo seleccionado.';
        return;
      }
      if( this.aula.idaula.id == null ){
        this.msg = 'No hay un aula seleccionado.';
        return;
      }
      if( this.semana.idsemana.length == 0 ){
        this.msg = 'No hay dias seleccionados.';
        return;
      }

      var idprograma = this.programa.id;
      var idmodulo = this.mod.id;
      var idaula = this.aula.idaula.id;
      var sem = {};
      this.semana.idsemana.forEach( function(e){
        sem[e.id] = true;
      });
      var input = { idprograma:idprograma,idmodulo:idmodulo,idaula:idaula,semana:sem }


      var sql = gql`mutation{ asignarAula(input:${window.stringifyObject(input)}){ok,errors{message}} }`;
      window.console.log( sql );
      var vue = this;

      this.$apollo.mutate({
          mutation: sql,
      }).then((data) => {
        if(data.data.asignarAula.ok){
          vue.$refs.alertar.success();
          vue.mod.aula.sede = vue.sede.idsede.nombre;
          vue.mod.aula.aula = vue.aula.idaula.nombre;
          //window.$('#modal-asig-aula').modal('hide');
        }else{
          var errores = JSON.stringify(data.data.asignarAula.errors);
          var obj = JSON.parse( errores );
          var vals = '';
          obj.forEach(function(k){ vals += Object.values(k)+"-\n\t"; });
          //vue.msg = vals;
          vue.activo = true;
          vue.$refs.alertar.invalido( vals );
        }

        window.console.log(data);
      }).catch((error) => {
        vue.$refs.alertar.invalido();
        this.activo = true;
        window.console.error(error);
        //vue.msg = error;
        vue.$refs.alertar.invalido( error );
      })



    }
  },
  mounted(){
    var xp = window.sessionStorage.xprograma;
    if( xp != null ) {
      var pp = JSON.parse( xp );
      this.programa.id = pp.id;
      this.programa.nombre = pp.nombre_compuesto;
      this.programa.sede = pp.idsede;
    }
    //window.console.log( "--------------- asigaulas:::",window.stringifyObject(this.programa),xp )
  }
}
</script>